import { Table } from "reactstrap";
import BaseParagraph from "../baseComponents/baseParagraph";
import { useSelector } from "react-redux";
import useColors from "../customHooks/useColors";

import { useState, useEffect } from "react";
import BaseButton from "../baseComponents/baseButton";
import { Container, Row, Col } from "reactstrap";
import useBootstrap from "../customHooks/useBootstrap";
import AddModal from "../utilComponents/AddModal";

import TransactionDetails from "./TransactionDetails";

const TransactionsTable = () => {
  const userState = useSelector((state) => state.userState);

  const transactions = userState.points;
  const numberOfTransactions = transactions.length;

  const { trashold8 } = useBootstrap();

  const [pointsSelectedId, setPointsSelectedId] = useState(null);

  const [currentColors] = useColors();

  const VTransactionTable = ({ openModal }) => (
    <Container fluid>
      <Row>
        <Col {...trashold8}>
          <div
            style={{
              backgroundColor: currentColors.septenary,
              margin: "20px 0",
              padding: "8px",
            }}
          >
            <Table
              responsive
              style={{
                backgroundColor: currentColors.septenary,
                margin: "auto 0",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "100px" }}>
                    <BaseParagraph
                      style={{ color: currentColors.tertiary }}
                      bold
                    >
                      date
                    </BaseParagraph>
                  </th>
                  <th>
                    <BaseParagraph
                      style={{ color: currentColors.tertiary }}
                      bold
                    >
                      activity
                    </BaseParagraph>
                  </th>
                  <th style={{ textAlign: "right" }}>
                    <BaseParagraph
                      style={{ color: currentColors.tertiary }}
                      bold
                    >
                      points
                    </BaseParagraph>
                  </th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction) => {
                  const vOnClick = transaction.isClickable
                    ? () => {
                        //openTransactionDetails(transaction.points_id);
                        setPointsSelectedId(transaction.points_id);
                        openModal();
                      }
                    : () => {};
                  return (
                    <tr
                      style={{
                        cursor: transaction.isClickable ? "pointer" : "auto",
                      }}
                      key={transaction.points_id}
                      onClick={vOnClick}
                    >
                      <td style={{ color: currentColors.tertiary }}>
                        <BaseParagraph
                          style={{
                            color: transaction.isClickable
                              ? currentColors.primary
                              : currentColors.tertiary,
                          }}
                          bold={transaction.isClickable}
                          translate={false}
                        >
                          {transaction.points_date}
                        </BaseParagraph>
                      </td>
                      <td>
                        <BaseParagraph
                          style={{
                            color: transaction.isClickable
                              ? currentColors.primary
                              : currentColors.tertiary,
                          }}
                          bold={transaction.isClickable}
                        >
                          {transaction.points_type_name}
                        </BaseParagraph>
                      </td>
                      <td
                        style={{
                          color: currentColors.tertiary,
                          textAlign: "right",
                        }}
                      >
                        <BaseParagraph
                          style={{
                            color: transaction.isClickable
                              ? currentColors.primary
                              : currentColors.tertiary,
                          }}
                          bold={transaction.isClickable}
                          translate={false}
                        >{`${
                          transaction.points < 0
                            ? "-"
                            : transaction.points > 0
                            ? "+"
                            : ""
                        }${transaction.points}`}</BaseParagraph>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              {numberOfTransactions === 0 && (
                <BaseParagraph>noActiveTransactions</BaseParagraph>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );

  const ModalConent = () => (
    <TransactionDetails selectedPointsId={pointsSelectedId} />
  );

  return (
    <AddModal
      Component={VTransactionTable}
      ModalContent={ModalConent}
      ModalHeader={() => <BaseParagraph>transactionsPage</BaseParagraph>}
    />
  );
};

export default TransactionsTable;
